/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import Entity from 'fierry/data/entity';


export default class User extends Entity
{
};
